
///
/// Mobile navigation - expand and collapse child navigation lists
///

export function SetUpMobileNavExpanders() {

	var toggleButtons = document.querySelectorAll('#MobileNavigationList .mobile-navigation__expander');
	var expandedClassName = 'expanded';

	//
	// Add a click event handler to each expand/collapse button to act on the related child list
	//
	if (toggleButtons.length) {
		for (var i = 0; i < toggleButtons.length; i++) {

			var button = toggleButtons[i];

			button.addEventListener('click', function () {

				this.classList.add('clicked');


				var parentSpan = this.parentNode; // findAncestor(button, '.mobile-navigation__list-item-wrapper');

				if (parentSpan) {

					var ul = parentSpan.nextElementSibling; // n.b. this requires a pollyfill

					if (ul) {

						if (this.classList.contains(expandedClassName)) {
							// child list is expanded -> close it
							this.setAttribute('aria-expanded', 'false');
							this.classList.remove(expandedClassName);
							ul.setAttribute('aria-hidden', 'true');
							ul.classList.remove(expandedClassName);
						} else {
							// child list is not expanded -> open it
							this.setAttribute('aria-expanded', 'true');
							this.classList.add(expandedClassName);
							ul.setAttribute('aria-hidden', 'false');
							ul.classList.add(expandedClassName);
						}

					}
				}
			})
		}
	}

}